const Theme = {
  logo_image_url:'vg.png',
  logo_height: 150,
  body_background_color: '#000F47',
  token_hidden: true,
  number_hidden: true,

  button_color : '#034EA2',
  button_radius: 10,
  text_font: `'Arial', sans-serif`,

  title_font: `'Oswald', sans-serif`,
}

export default Theme
